import React, { useMemo } from 'react';
import format from 'date-fns/format';
import PropTypes from 'prop-types';

import BoxWithTwoSections from 'components/BoxWithTwoSections';
import { DATE_WITH_HOUR } from 'utils/dateFormat';
import { transferDetails as TEXT } from 'locales/en/transfer';

const TransferDetails = ({ transfer }) => {
  const leftSide = useMemo(
    () => ({
      created_at: format(new Date(transfer.created_at), DATE_WITH_HOUR),
      reference: transfer.reference,
      integration: transfer.integration_id || '-',
      related: '-',
    }),
    [transfer]
  );
  const rightSide = useMemo(
    () => ({
      source: transfer.source_account_code,
      destination: transfer.destination_account_code,
      amount: transfer.amountToDisplay,
      transferCode: transfer.transfer_code,
    }),
    [transfer]
  );
  return (
    <>
      <h2 className="text-javelin-gray-dark lg:text-xl text-base font-bold">
        {TEXT.detailsHeader}
      </h2>
      <BoxWithTwoSections
        textObject={TEXT}
        data={{ left: leftSide, right: rightSide }}
      />
    </>
  );
};

TransferDetails.propTypes = {
  transfer: PropTypes.shape({}),
};
TransferDetails.defaultProps = {
  transfer: {},
};

export default TransferDetails;
